import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
// Vor styles.css: base.css bringt die Token, styles.css importiert danach die
// ui-react-Komponentenstile und setzt die App-Regeln. Diese Reihenfolge ist
// dieselbe wie in accountingFox und infrastructureDog — bei gleicher
// Spezifitaet gewinnt sonst die falsche Seite.
import '@weretradeit/design-system/v3/base.css';
import './styles.css';
import { I18nProvider } from './i18n';

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <RouterProvider router={router} />
      </I18nProvider>
    </React.StrictMode>
  );
}
